"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryByPhoneNumber = getCountryByPhoneNumber;
exports.combineCountryPhoneNumber = combineCountryPhoneNumber;
const countries_1 = require("./countries");
/*
 * Find which country a phone number is from, based on prefix
 */
function getCountryByPhoneNumber(number) {
    if (number !== null) {
        let digits = number.replace(/\D/gi, "");
        if (digits.startsWith("00"))
            digits = digits.substring(2);
        let matches = countries_1.COUNTRY_LIST.filter(({ country, dial_code }) => country && digits.startsWith(dial_code));
        if (matches.length > 0) {
            let country = matches.sort(({ dial_code: d1 }, { dial_code: d2 }) => d2.length - d1.length)[0];
            if (country.code === "CA")
                country = countries_1.COUNTRY_BY_CODE.US; // sorry Canada
            return { country, countryCode: country.code, number: digits.substring(country.dial_code.length) };
        }
        // historical UK numbers in non-international form
        if (digits.charAt(0) === "0" && digits.charAt(1) !== "0" && [10, 11].includes(digits.length)) {
            return { country: countries_1.COUNTRY_BY_CODE.GB, countryCode: "GB", number };
        }
    }
    return { country: null, countryCode: null, number };
}
/*
 * Combine a country and a phone number in international format
 */
function combineCountryPhoneNumber(country, phoneNumber) {
    if (phoneNumber !== null && phoneNumber.length > 0) {
        return (country !== null ? `+${country.dial_code}` : "") + phoneNumber.replace(/\D/gi, "");
    }
    return null;
}
